import React from "react";
import heroImg from "../../assets/policies/heroImg.webp";

const LegalAndCompliance = () => {
  return (
    <section
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-once="true"
      className="relative pt-24 md:pt-32 lg:pt-28 pb-4 md:pb-4 lg:pb-8 
                      px-4 md:px-8 lg:px-12 
                      bg-[#070021] text-white 
                      font-poppins tracking-widest"
    >
      {/* Left Blur  */}
      <div
        className="absolute left-0 top-0 w-[40%] h-[40%] rounded-full 
                           bg-[#1a99c03b] blur-[100px] md:blur-[140px] lg:blur-[180px] 
                           z-0"
      ></div>

      {/* Right Blur */}
      <div
        className="absolute right-0 top-0 w-[45%] h-[45%] rounded-full 
                           bg-[#1a99c03b] blur-[120px] md:blur-[160px] lg:blur-[200px] 
                           z-0"
      ></div>

      <div className="absolute top-0 -right-12 w-[40%]">
        <img
          src={heroImg}
          alt="Hero Background"
          className="inset-0 w-[100%] h-full object-cover "
          loading="eager"
          fetchpriority="high"
        />
      </div>
      <div className="max-w-[95%] mx-auto">
        <h1 className="text-3xl md:text-4xl lg:text-3xl font-semibold mb-6">
          Legal & Compliance
        </h1>
        <span className="text-[#49D093] font-semibold text-sm md:text-base lg:text-[14px] leading-relaxed mb-1">
          Transparency. Governance. Trust.
        </span>
        <div
          className="h-[0.8px] w-full mb-8 
                      bg-gradient-to-r from-[#49D093] via-[#38b87eef] to-[#0C226E]"
        />
        {/* General Information */}
        <div data-aos="fade-up" data-aos-duration="1000" data-aos-once="true">
          <p
            className="text-[10px] md:text-[12px] lg:text-[12px] 
                      font-extralight ml-2 mb-2 leading-relaxed lg:w-[90%]"
          >
            At {""}
            <span className="text-[#49D093]">Mark9 Pte. Ltd.</span>, we believe
            that innovation and trust go hand in hand. <br />
            As a global SAP consulting and product services company, we are
            committed to operating with integrity, protecting your data, and
            ensuring compliance with international privacy and security
            standards. <br /> This page provides a single view of our key legal
            and compliance policies that govern how we operate, protect
            information, and engage with our customers, partners, and website
            visitors. 
          </p>

          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 mt-6 text-[#49D093]"
          >
            Global Compliance Commitment
          </h2>

          <ul
            className="list-disc ml-6 
                         text-[10px] md:text-[12px] lg:text-[12px] 
                         font-extralight space-y-1.5"
          >
            <li>Singapore Personal Data Protection Act (PDPA)</li>
            <li>EU General Data Protection Regulation (GDPR)</li>
            <li>
              ISO-aligned internal security practices for data handling and
              cloud operations
            </li>
            <li>SAP Partner integrity and data-processing standards.</li>
          </ul>
          <p className="text-[10px] md:text-[12px] lg:text-[12px] font-extralight ml-2 mt-4 mb-2 leading-relaxed lg:w-[90%]">
            We continually review our internal policies to align with evolving
            regulations and ensure that our global customers experience
            transparency, security, and accountability in every engagement.
          </p>
        </div>

        {/* Contact for Privacy & Legal Matters */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="200"
          className="mt-8"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Contact for Privacy & Legal Matters
          </h2>

          <p className="text-[10px] md:text-[12px] lg:text-[12px] font-extralight mb-2 ml-2 md:ml-2">
            For any inquiries regarding privacy, compliance, or data-related
            requests, <br /> please contact -{" "}
            <span className="text-[#49D093]">privacy@m9-solutions.com</span>
          </p>
          <p className="text-[10px] md:text-[12px] lg:text-[12px] font-extralight mb-2 ml-2 md:ml-2 mt-6">
            {" "}
            <span className="text-[#49D093] ">© 2025 Mark9 Pte Ltd</span> | Committed to data protection
            and compliance under PDPA & GDPR | Privacy Policy
          </p>
        </div>
      </div>
    </section>
  );
};

export default LegalAndCompliance;
